import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Main from "./Main";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AUTH_CLIENTID,
    authority: process.env.REACT_APP_AUTH_AUTHORITY,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

function renderApp() {
  ReactDOM.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Main />
      </MsalProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
}

// A página do paciente (/f/<token>) não passa pelo Azure AD: sem este catch uma
// falha de configuração do MSAL deixa a tela em branco também para ela.
msalInstance.initialize().then(renderApp, (error) => {
  console.error("Falha ao inicializar a autenticação do Azure AD", error);
  renderApp();
});

reportWebVitals();
